/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Ask_ConfirmInputs */

const en_us2_coach_extra_ask_confirm = /** @type {(inputs: Coach_Extra_Ask_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const pt_br2_coach_extra_ask_confirm = /** @type {(inputs: Coach_Extra_Ask_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const es_419_coach_extra_ask_confirm = /** @type {(inputs: Coach_Extra_Ask_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const pt_pt2_coach_extra_ask_confirm = /** @type {(inputs: Coach_Extra_Ask_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const fr_fr2_coach_extra_ask_confirm = /** @type {(inputs: Coach_Extra_Ask_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer`)
};

const de_de2_coach_extra_ask_confirm = /** @type {(inputs: Coach_Extra_Ask_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen`)
};

const it_it2_coach_extra_ask_confirm = /** @type {(inputs: Coach_Extra_Ask_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Coach_Extra_Ask_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_ask_confirm = /** @type {((inputs?: Coach_Extra_Ask_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Ask_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_ask_confirm(inputs)
	if (locale === "es-419") return es_419_coach_extra_ask_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_ask_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_ask_confirm(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_ask_confirm(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_ask_confirm(inputs)
	return en_us2_coach_extra_ask_confirm(inputs)
});
export { coach_extra_ask_confirm as "coach-extra.ask_confirm" }